import React from 'react';
import { Field } from 'formik';
import { CheckboxLabel, CheckboxInput } from './wrapper/CheckboxWrapper';

const Checkbox = (props) => (
  <CheckboxLabel>
    <Field type="checkbox" name={props.name} value={props.value} />
    <CheckboxInput />
    {props.children}
  </CheckboxLabel>
);

export default Checkbox;